module.exports = __webpack_public_path__ + "static/media/purepapercolor-skin-black-009-1200x2490.05076acc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/purepapercolor-skin-black-009-1200x2490.jpg
// module id = 1088
// module chunks = 37